import * as THREE from "three";
import {CBARLightAsset, CBARLightAssetProperties} from "./CBARLightAsset";
import {CBARContext} from "../../CBARContext";

export class CBARHemisphereLight extends CBARLightAsset {

    constructor(context:CBARContext) {
        super(context);
        this._light.castShadow = true;
        this.setRenderObject(this.light)
    }

    protected _light = new THREE.HemisphereLight();

    public get light():THREE.HemisphereLight {
        return this._light
    }

    get description() : string {
        return "Hemisphere light"
    }

    load(basePath:string|undefined, json: CBARLightAssetProperties): Promise<CBARHemisphereLight> {
        return new Promise<CBARHemisphereLight>((resolve) => {
            return super.load(basePath, json).then(()=>{
                resolve(this)
            })
        })
    }
}